import { AgentComponentType } from '@reach/shared-types/agent-components';
import { Navigate, Route, Routes } from 'react-router-dom';
import { agentBuilderNestedRoutes, appRoutes } from '../../app-routes';
import { FlagProtectedRoute } from '../../components/FlagProtectedRoute';
import { ToolsListPage } from '../ai-tools';
import { TOOLS_PAGE_COPY } from './agents-copy';
import { AgentsNav } from './agents-nav';
import styles from './AgentBuilder.module.css';
import { ComponentListPage } from './component-list';
import { ComponentPage } from './component-page';
import { AgentsOverview } from './overview';
import { VoiceTemplatePage } from './template-page';
import { TenantPreviewPage } from './tenant-preview-page';

const COMPONENT_SECTIONS = [
  { type: AgentComponentType.SKILL, path: agentBuilderNestedRoutes.SKILLS },
  { type: AgentComponentType.GUIDANCE, path: agentBuilderNestedRoutes.GUIDANCE },
  { type: AgentComponentType.ESCALATION, path: agentBuilderNestedRoutes.ESCALATIONS },
];

/** The partner's agent builder: its own navigation beside the section being viewed. */
export const AgentBuilder = () => (
  <div className={styles.builder}>
    <AgentsNav />
    <div className={styles.section}>
      <Routes>
        <Route index element={<AgentsOverview />} />
        <Route path={agentBuilderNestedRoutes.VOICE_TEMPLATE}>
          <Route index element={<VoiceTemplatePage />} />
          <Route path={agentBuilderNestedRoutes.TENANT_PREVIEW} element={<TenantPreviewPage />} />
        </Route>
        {COMPONENT_SECTIONS.map(({ type, path }) => (
          <Route key={type} path={path}>
            <Route index element={<ComponentListPage type={type} />} />
            <Route
              path={agentBuilderNestedRoutes.NEW_COMPONENT}
              element={<ComponentPage type={type} />}
            />
            <Route path={agentBuilderNestedRoutes.COMPONENT} element={<ComponentPage type={type} />} />
          </Route>
        ))}
        <Route
          path={agentBuilderNestedRoutes.TOOLS}
          element={
            <FlagProtectedRoute flag="enable-partner-mcp-authoring" redirectTo={appRoutes.AGENTS}>
              <ToolsListPage description={TOOLS_PAGE_COPY.description} />
            </FlagProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to={appRoutes.AGENTS} replace />} />
      </Routes>
    </div>
  </div>
);
